import { apiUrl } from 'src/config'
import { reportError } from 'src/sentry'
import localStorageWrapper from 'src/util/localStorageWrapper'

export const types = {
  SAVE_QUERY_PARAMS: 'SAVE_QUERY_PARAMS',
  SAVE_CHECKFORM_INPUTS: 'SAVE_CHECKFORM_INPUTS',

  FETCH_USERDATA_START: 'FETCH_USERDATA_START',
  FETCH_USERDATA_END: 'FETCH_USERDATA_END',

  SET_PROMOCODE_AND_REFERRALCODE: 'SET_PROMOCODE_AND_REFERRALCODE',

  FETCH_AIRBNBDATA_START: 'FETCH_AIRBNBDATA_START',
  FETCH_AIRBNBDATA_END: 'FETCH_AIRBNBDATA_END',

  SET_AIRBNB_RECEIPTS: 'SET_AIRBNB_RECEIPTS',
  DELETE_AIRBNB_RECEIPT: 'SET_AIRBNB_RECEIPT',

  SET_AIRBNB_DATA_FROM_FORM: 'SET_AIRBNB_DATA_FROM_FORM',
  SET_AIRBNB_FORM_DONE: 'SET_AIRBNB_FORM_DONE',

  SET_AIRBNB_STRONGER_TOGETHER_BANNER_OPEN:
    'SET_AIRBNB_STRONGER_TOGETHER_BANNER_OPEN',

  RESET_USERDATA: 'RESET_USERDATA',
  SET_AUTHENTICATED: 'SET_AUTHENTICATED',
  SET_SIGNINLINK_LOADED: 'SET_SIGNINLINK_LOADED',

  SET_LOGIN_INFO: 'SET_LOGIN_INFO',

  SAVE_SOURCE_FROM_UTM: 'SAVE_SOURCE_FROM_UTM',

  SET_NOTICE_SETTINGS: 'SET_NOTICE_SETTINGS',
  SET_NOTICE_HIDDEN: 'SET_NOTICE_HIDDEN',
  SET_NOTICE_BLOCKING: 'SET_NOTICE_BLOCKING',
}

export const actions = {
  saveSourceFromUtmTags: (source) => ({
    type: types.SAVE_SOURCE_FROM_UTM,
    payload: {
      source,
    },
  }),
  setAuthenticated: ({ user, signInLinkLoaded }) => ({
    type: types.SET_AUTHENTICATED,
    payload: {
      user,
      isAuthenticated: !!user,
      loading: false,
      firebaseLoaded: true,
      signInLinkLoaded,
    },
  }),
  resetUserData: ({ firebaseLoaded, signInLinkLoaded }) => ({
    type: types.RESET_USERDATA,
    payload: {
      firebaseLoaded,
      signInLinkLoaded,
      loading: !firebaseLoaded,
    },
  }),
  setSignInLinkLoaded: (signInLinkLoaded) => ({
    type: types.SET_SIGNINLINK_LOADED,
    payload: {
      signInLinkLoaded,
    },
  }),
  setLoginInfo: ({ loginEmail, loginKey }) => ({
    type: types.SET_LOGIN_INFO,
    payload: { loginEmail, loginKey },
  }),
  saveQueryParams: (queryParams) => ({
    type: types.SAVE_QUERY_PARAMS,
    payload: { ...queryParams },
  }),
  saveCheckFormInputs: (formInputs) => ({
    type: types.SAVE_CHECKFORM_INPUTS,
    payload: { ...formInputs },
  }),
  signedIn: (user) => async (_dispatch, _getState) => {
    const token = await user.getIdToken()
    await fetch(`${apiUrl}/currentUserV2/loggedInHook`, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${token}`,
        credentials: 'include',
        referrerPolicy: 'no-referrer-when-downgrade',
      },
    })
  },
  setPromoCodeAndReferralcode: (payload) => ({
    type: types.SET_PROMOCODE_AND_REFERRALCODE,
    payload,
  }),

  /* ----- AIRBNB ---- */
  setAirbnbStrongerTogetherBannerOpen: ({ open }) => ({
    type: types.SET_AIRBNB_STRONGER_TOGETHER_BANNER_OPEN,
    payload: { open },
  }),
  setAirbnbDataFromForm: ({
    key,
    loginKey,
    fullName,
    email,
    activeReferralLink,
  }) => ({
    type: types.SET_AIRBNB_DATA_FROM_FORM,
    payload: { key, loginKey, fullName, email, activeReferralLink },
  }),
  setAirbnbFormDone: () => ({
    type: types.SET_AIRBNB_FORM_DONE,
  }),
  setAirbnbReceipts: (receipts) => ({
    type: types.SET_AIRBNB_RECEIPTS,
    payload: receipts,
  }),
  deleteAirbnbReceipt: (id) => ({
    type: types.DELETE_AIRBNB_RECEIPT,
    payload: { id },
  }),
  fetchAirbnbData: () => async (dispatch, getState) => {
    const { auth, airbnbDataLoading } = getState()
    if (!auth.loaded || !auth.isAuthenticated || airbnbDataLoading) {
      return
    }

    dispatch({
      type: types.FETCH_AIRBNBDATA_START,
    })
    const token = await auth.user.getIdToken()
    let fetched
    try {
      fetched = await fetch(`${apiUrl}/currentUserV2/airbnbData`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
    } catch (err) {
      reportError(err)
      return dispatch({
        type: types.FETCH_AIRBNBDATA_END,
        error: 'Failed to fetch airbnbdata',
      })
    }
    const response = await fetched.json()
    if (response.statusCode !== 200) {
      reportError(response)
      return dispatch({
        type: types.FETCH_AIRBNBDATA_END,
        error: response,
      })
    }
    dispatch({
      type: types.FETCH_AIRBNBDATA_END,
      payload: response.result,
    })
  },
  setNoticeSettings: ({ blocking, hidden }) => ({
    type: types.SET_NOTICE_SETTINGS,
    payload: { blocking, hidden },
  }),
  setNoticeHidden: (hidden) => {
    localStorageWrapper.setItem('noticeHiddenNew', hidden)
    return {
      type: types.SET_NOTICE_HIDDEN,
      payload: hidden,
    }
  },
  setNoticeBlocking: (blocking) => {
    localStorageWrapper.setItem('noticeNonBlocking', blocking)
    return {
      type: types.SET_NOTICE_BLOCKING,
      payload: blocking,
    }
  },
}
